//Package imports
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Typography } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";

// Global variables

// Component
function ProductSelection(props) {
  // Hooks
  const dispatch = useDispatch();

  // State
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Redux state
  let products = useSelector((state) => state.defs.siteConfig.products);
  const { mode } = useSelector((state) => state.assignment);

  // React logic hooks
  useEffect(() => {
    setSelectedProduct(products[0]["productId"]);
    dispatch(assignmentSliceActions.setProduct(products[0]["productId"]));
  }, [products]);

  // To change product
  const changeProduct = (event) => {
    setSelectedProduct(event.target.value);
    dispatch(assignmentSliceActions.setProduct(event.target.value));
  };

  // JSX template
  return (
    <>
      <Typography
        color="#5f5600ff"
        sx={{
          ml: 4,
          letterSpacing: 1,
          fontSize: "1.2rem",
          fontWeight: "500",
          "@media (min-width: 1636px)": {
            fontSize: "1.4rem",
          },
        }}
      >
        Product:
      </Typography>
      <FormControl fullWidth sx={{ mx: 1, mb: 1 }} size="small">
        <Select
          value={selectedProduct}
          onChange={changeProduct}
          disabled={mode == "edit"}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
          sx={{
            borderRadius: 5,
            borderColor: "#FFFFFF",
            backgroundColor: "#F5F5F5",
            "@media (min-width: 1636px)": {
              fontSize: "1.2rem",
            },
          }}
        >
          {products &&
            products.map((val, index) => {
              return (
                <MenuItem value={val.productId} key={`${index}_Product`}>
                  {/* {val.productName} */} {"Vocablab"}
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    </>
  );
}

export default ProductSelection;
